import { CreditCard, Home, Car, Store } from 'lucide-react';

export const loanTypes = [
  {
    id: 'ihtiyac',
    title: 'İhtiyaç Kredisi Hesaplama',
    icon: <CreditCard className="w-5 h-5" />,
    minAmount: 10000,
    maxAmount: 1000000,
    step: 10000,
    amounts: [10000, 250000, 500000, 750000, 1000000],
    getMaxTerm: (amount: number) => {
      if (amount < 125000) return 36;
      if (amount <= 250000) return 24;
      return 12;
    },
    terms: {
      low: [3, 6, 9, 12, 24, 36],
      medium: [6, 12, 18, 24],
      high: [3, 6, 9, 12]
    },
    description: 'Nakit ihtiyaçlarınız için uygun faizli kredi seçenekleri',
    path: '/ihtiyac-kredisi'
  },
  {
    id: 'tasit',
    title: 'Taşıt Kredisi Hesaplama',
    icon: <Car className="w-5 h-5" />,
    minAmount: 10000,
    maxAmount: 1000000,
    step: 10000,
    amounts: [10000, 250000, 500000, 750000, 1000000],
    getMaxTerm: (amount: number) => {
      if (amount <= 2500000) return 48;
      if (amount <= 5000000) return 36;
      if (amount <= 6500000) return 24;
      if (amount <= 7500000) return 12;
      return 0;
    },
    terms: {
      level1: [12, 24, 36, 48],
      level2: [12, 24, 36],
      level3: [12, 24],
      level4: [12],
      level5: [0]
    },
    description: 'Araç alımlarınız için özel kredi imkanları',
    path: '/tasit-kredisi'
  },
  {
    id: 'konut',
    title: 'Konut Kredisi Hesaplama',
    icon: <Home className="w-5 h-5" />,
    minAmount: 100000,
    maxAmount: 5000000,
    step: 10000,
    amounts: [100000, 1000000, 2500000, 3000000, 5000000],
    minTerm: 12,
    maxTerm: 120,
    description: 'Ev sahibi olmak için uzun vadeli finansman çözümleri',
    path: '/konut-kredisi'
  },
  {
    id: 'kobi',
    title: 'Kobi Kredisi Hesaplama',
    icon: <Store className="w-5 h-5" />,
    minAmount: 50000,
    maxAmount: 2000000,
    step: 50000,
    amounts: [50000, 500000, 1000000, 1500000, 2000000],
    minTerm: 3,
    maxTerm: 60,
    description: 'İşletmeniz için uygun finansman çözümleri',
    path: '/kobi-kredisi'
  }
];